import React, { Component } from "react";
import TabHeader from "../../forms/tabHeader";
import { GRAPH, TABLE } from "../../../store/types";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { connect } from "react-redux";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import moment from "moment";

class NavData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: GRAPH,
    };
  }

  onClick = (type) => () => {
    this.setState({
      active: type,
    });
  };

  render() {
    const { navData } = this.props;
    const navSortData = navData.sort(function (a, b) {
      var xDate = a.fn_fromdt.split("/")[2];
      var yDate = b.fn_fromdt.split("/")[2];
      var keyA = parseFloat(xDate),
        keyB = parseFloat(yDate);
      return keyA - keyB;
    });
    console.log(navSortData, "navSortData");

    const graphData = navSortData.map((item) => ({
      name: moment(item.fn_fromdt, "DD/MM/YYYY").format("DD MMM YYYY"),
      value: item.fn_nav,
    }));
    const range = navSortData.map((item) => item.fn_nav);
    const min = Math.min.apply(null, range);
    const max = Math.max.apply(null, range);

    return (
      <div>
        <div className="tab-container nav-t-c">
          <TabHeader
            value="NAV Graph"
            active={this.state.active === GRAPH}
            onClick={this.onClick(GRAPH)}
          />

          <TabHeader
            value="NAV Table"
            active={this.state.active === TABLE}
            onClick={this.onClick(TABLE)}
          />
        </div>
        {!!navData.length ? (
          <React.Fragment>
            {this.state.active === GRAPH ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <AreaChart
                  width={450}
                  height={300}
                  data={graphData}
                  animationDuration={10}
                  className="nav-garphs"
                >
                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#fef5ec" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#005DAC" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <XAxis
                    dataKey="name"
                    height={60}
                    tick={<CustomizedAxisTick />}
                  />
                  <YAxis type="number" domain={[min, max]} />
                  <CartesianGrid vertical={false} />
                  <Tooltip />
                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke="#005DAC"
                    fillOpacity={1}
                    fill="url(#colorUv)"
                  />
                </AreaChart>
              </div>
            ) : (
              <div style={{ display: "flex" }} className="navTable">
                <Table stickyHeader>
                  <TableHead
                    style={{
                      backgroundColor: "#f8efe0",
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5,
                    }}
                  >
                    <TableRow>
                      <TableCell
                        align="center"
                        style={{
                          color: "#093f74",
                          fontSize: 13,
                          padding: "7px 40px 7px 16px",
                        }}
                      >
                        Date
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          color: "#093f74",
                          fontSize: 13,
                        }}
                        className="nav-value-responsive"
                      >
                        Nav Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {navData.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell
                          component="th"
                          scope="row"
                          align="center"
                          style={{
                            fontSize: 15,
                          }}
                        >
                          {item.fn_fromdt}
                        </TableCell>

                        <TableCell
                          component="th"
                          scope="row"
                          align="center"
                          style={{
                            fontSize: 15,
                          }}
                        >
                          {item.fn_nav}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            )}
          </React.Fragment>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              fontSize: 15,
              height: 300,
              margin: "0px 10px",
              color: "#005DAC",
            }}
          >
            Please fill all the details to display NAV Graph/ NAV Table
          </div>
        )}
      </div>
    );
  }
}

export default connect(({ transactionHistory }) => {
  const { navData } = transactionHistory;
  return { navData };
})(NavData);

class CustomizedAxisTick extends Component {
  render() {
    const { x, y, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="end"
          fill="#666"
          transform="rotate(-35)"
        >
          {payload.value}
        </text>
      </g>
    );
  }
}
